<template>
  <div class="order-detail bg-white">
    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
      <!-- <el-tab-pane label="订单" name="orders">
        <div>
          <el-input placeholder="请输入订单号" v-model="order_id" class="search-bar" prefix-icon="el-icon-search" @change="getOrderList">
          </el-input>
          <el-collapse>
            <el-collapse-item class="m-15 pl-10" v-for="(order,index) in orderList" :key="index">
              <template slot="title">
                <div style="width:100%;display:flex;justify-content:space-between;">
                  <span style="">
                    <span class="color-primary" v-if="order.status === 'unpaid'">待付款</span>
                    <span class="color-green" v-else-if="order.status === 'unsend'">待发货</span>
                    <span v-else-if="order.status === 'unreceived'">待收货</span>
                    <span v-else-if="order.status === 'finished'">已完成</span>
                    <span v-else-if="order.status === '5'">退款中</span>
                    <span v-else-if="order.status === 'cancel'">已关闭</span>
                  </span>
                  <span class="color-sliver" style="float:right;">{{order.createTime||'2021-02-01 16:00:01'}}</span>
                </div>
              </template>
              <div v-for="(skuItem,skuIndex) in order.skus" :key="skuIndex" class="pb-10" style="display:flex;">
                <img :src="skuItem.sku.picture" style="display:inline-block;margin-right:10px;width:100px;height:100px;"/>
                <div style="position:relative;">
                  <div class="clamp-2">{{skuItem.sku.title}}</div>
                  <div style="position: absolute;bottom: 0;">
                    <div class="color-primary">￥{{skuItem.price}}</div>
                    <div class="color-sliver">×{{skuItem.count}}</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="mb-5"><span class="color-sliver label">下单时间: </span>{{order.createTime||'2021-02-01 16:00:01'}}</div>
                <div class="mb-5"><span class="color-sliver label">买家留言：</span>{{order.user_note||"无"}}</div>
                <div class="mb-15"><span class="color-sliver label">收货信息: </span>{{order.shopInfo||'无'}}</div>
              </div>
              <div>
                <el-button class="ml-auto mr-10" size="mini" round @click="send(index,3)">
                  核对地址
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-tab-pane> -->
      <!-- <el-button class="ml-auto" type="primary" plain size="mini" round @click="send()">
        发货
      </el-button> -->
      <!-- <el-button class="ml-auto" type="primary" size="mini" round @click="send()">
        备注
      </el-button> -->
      <el-tab-pane label="商品" name="goods">
        <div>
          <el-input placeholder="请输入商品名称" v-model="title" class="search-bar" prefix-icon="el-icon-search" @change="getProductList">
          </el-input>
          <!-- <div class="search-bar pt-15 pr-30 pl-30">
            搜索栏
          </div> -->
          <div class="p-30 good-item" v-for="(item,index) in productList" :key="index" style="position:relative;display:flex;">
            <img :src="item.picture" style="display:inline-block;width:100px;height:100px;margin-right:15px"/>
            <div>
              <div class="clamp-2">{{item.title}}</div>
              <div class="color-primary" style="position:absolute;bottom:30px;">￥{{item.shop_price}}</div>
              <el-button style="position:absolute;bottom:30px;right:30px;" class="ml-auto" type="primary" size="mini" round @click="send(index,2)">
                发送
              </el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getProductList } from '@/api/product.js'
import { getOrderList } from '@/api/order.js';
import { mapActions, mapGetters } from 'vuex';
export default {
  data(){
    return {
      activeName: 'goods',
      orderList: null,
      productList: null,
      order_id: '',
      title: ''
    }
  },
  mounted(){
    this.handleClick()
  },
  methods:{
    ...mapActions(['webSocketSend']),
    handleClick(){
      switch(this.activeName){
        case 'orders':
          this.getOrderList()
          break;
        case 'goods':
          this.getProductList()
          break;
      }
    },
    send(index,type){
      // type 0消息 1图片 2商品 3订单 前端判断
      let msg = ''
      if(type===2){
        if(!this.productList){return}
        let data = {
          id: this.productList[index].id,
          picture: this.productList[index].picture,
          title: this.productList[index].title,
          price: this.productList[index].shop_price
        }
        msg = JSON.stringify(data)
      }
      if(type===3){
        if(!this.orderList){return}
        let data = {
          count: this.orderList[index].total_count,
          orderId: this.orderList[index].order_id,
          createTime: this.orderList[index].createTime||'2021-02-01 16:00:01',
          address: this.orderList[index].address||'广东省深圳市红袜子',
          title: this.orderList[index].skus[0].sku.title,
          picture: this.orderList[index].skus[0].sku.picture,
          totalAmount: this.orderList[index].total_amount
        }
        msg = JSON.stringify(data)
      }
      this.webSocketSend({msg,type})
    },
    async getOrderList(){
      let res = await getOrderList({
        userId: this.currentId,
        order_id: this.order_id
        // offset: 0,
        // limit: 1
      })
      this.orderList = res.results||[]
    },
    async getProductList(){
      let res = await getProductList({status:'on',title:this.title});
      this.productList = res.results || []
    }
  },
  computed:{
    ...mapGetters([
      'currentId'
    ])
  }

}
</script>

<style lang="scss" scoped>
.order-detail{
  height: 100%;
  width:30vw;
  overflow: scroll;
}
.good-item{
  border-bottom: 0.5px solid #D8D8D8;
}
.label{
  display: inline-block;
  width:75px;
}
::v-deep
.el-collapse-item{
  background: #F9F9F9;
}
::v-deep
.el-collapse-item__header{
  background: #F9F9F9;
}
::v-deep
.el-collapse-item__content{
  background: #F9F9F9;
  padding-bottom: 10px;
}
.search-bar{
  margin-left:15px;
  margin-right:15px;
  margin-bottom:15px;
}
::v-deep
.el-input{
  width: calc(100% - 30px)
}
</style>